import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'

export default function useQuestionTypeEdit() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { route, router } = useRouter()
  const { getItem, updateItem } = useLambda()
  const questionType = ref({})
  const isSubmitting = ref(false)
  const questionTypeId = route.value.params.id
  const query = { _id: oid(questionTypeId) }
  const collection = 'question_type'

  const show = async () => {
    isSubmitting.value = true

    try {
      const item = await getItem({ collection, query })
      if (!item) throw new Error('Item not found')

      questionType.value = item
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.question_type_fetch_error'))
    } finally {
      isSubmitting.value = false
    }
  }

  const update = async data => {
    isSubmitting.value = true

    const payload = {
      name: data.name?.value,
    }

    try {
      const action = { $set: payload }

      await updateItem({ collection, query, action })

      showSuccessMessage(i18n.t('message.question_type_updated'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.question_type_update_error'))
    } finally {
      router.push({ name: 'organization-question-type-list' })
      isSubmitting.value = false
    }
  }

  return {
    update,
    show,
    questionType,
    isSubmitting,
  }
}
